import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ModalHelp from '../../../components/ModalHelp';
import { toast } from 'react-toastify';
import ContaServicoViewModel from '../../../viewmodel/ContaServicoViewModel';
import BackendErrorMessage from '../../../components/BackendErrorMessage';

type Props = {
  solicitacao: {
    id: string;
    descricao: string;
    unidadeId: string;
    unidadeNome: string;
    acessoMultiUnidadeSolicitado: boolean;
    perfilSolicitado?: string;
    perfilSolicitadoNome?: string;
  };
  onClose: () => void;
  onSuccess: () => void;
};

const AprovacaoModal: React.FC<Props> = ({ solicitacao, onClose, onSuccess }) => {
  const aprovar = async () => {
    try {
      await ContaServicoViewModel.aprovarSolicitacao(
        solicitacao.id,
        solicitacao.acessoMultiUnidadeSolicitado
      );
      toast.success('Solicitação aprovada com sucesso!');
      onSuccess();
    } catch (error) {
      toast.error(BackendErrorMessage(error) || 'Erro ao aprovar solicitação');
    }
  };

  const rejeitar = async () => {
    const motivo = prompt('Informe o motivo da rejeição:');
    if (!motivo) return;

    try {
      await ContaServicoViewModel.rejeitarSolicitacao(solicitacao.id, encodeURIComponent(motivo));
      toast.success('Solicitação rejeitada');
      onSuccess();
    } catch (error) {
      toast.error(BackendErrorMessage(error) || 'Erro ao rejeitar solicitação');
    }
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Aprovar Solicitação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
                <ModalHelp text="Avalie a solicitação de conta de serviço. Ao aprovar, uma conta será criada com as permissões do perfil solicitado. O solicitante receberá as credenciais por email." />
        <p><strong>Descrição:</strong> {solicitacao.descricao}</p>
        <p><strong>Unidade:</strong> {solicitacao.unidadeNome}</p>
        <p><strong>Acesso Multi-Unidade:</strong> {solicitacao.acessoMultiUnidadeSolicitado ? 'Sim' : 'Não'}</p>
        {solicitacao.perfilSolicitadoNome && (
          <p><strong>Perfil Solicitado:</strong> {solicitacao.perfilSolicitadoNome}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="danger" onClick={rejeitar}>Rejeitar</Button>
        <Button variant="success" onClick={aprovar}>Aprovar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AprovacaoModal;